import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { XCircle } from '@phosphor-icons/react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="bg-white rounded-lg shadow-lg border border-borders p-8 text-center">
          <XCircle size={80} weight="fill" className="text-orange-500 mx-auto mb-6" />
          
          <h1 className="text-3xl font-bold text-text_dark mb-4">
            Payment Canceled
          </h1>
          
          <p className="text-lg text-text_muted mb-8">
            Your payment was canceled. No charges were made to your account.
          </p>

          <div className="bg-yellow-50 p-4 rounded-sm border border-yellow-200 mb-8 text-left">
            <h4 className="font-bold text-text_dark mb-2">Having second thoughts?</h4>
            <p className="text-sm text-text_muted mb-2">
              We&apos;re here to help! If you have any questions about our pricing or features, please don&apos;t hesitate to reach out.
            </p>
            <p className="text-sm text-text_muted">
              Email: <a href="mailto:support@pestprohub.com" className="text-primary underline">support@pestprohub.com</a>
            </p>
          </div>

          <div className="flex gap-4 justify-center">
            <button
              onClick={() => navigate('/pricing')}
              className="px-6 py-3 bg-primary text-white rounded-sm hover:bg-primary/90"
            >
              View Pricing Again
            </button>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 border border-borders text-text_dark rounded-sm hover:bg-gray-50"
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
